export default "__VITE_ASSET__EjvPm3ad__"